import './environment.css'

export default function AboutEnvironment(){
    return (
        <div className='main-environment-about'>
            <h1>Enviromental Impact</h1>

            <div className='environment-about-lower'>
                <div className='environment-about-exp'>
                    <p>At Sarte, we recognize our responsibility to minimize environmental impact while 
                        driving progress. Through sustainable practices, resource efficiency, and innovative 
                        solutions, we are committed to reducing our footprint and fostering a greener future. 
                        Every project we undertake reflects our dedication to balancing growth with 
                        environmental stewardship, ensuring that our work today contributes to a more 
                        sustainable tomorrow.</p>
                </div>

                <div className='environment-about-pic'>
                </div>
            </div>
        </div>
    )
}